<template>
    <v-row>
        <v-col cols="12">
            <slot name="first-line" />
        </v-col>
    </v-row>
</template>
